<template>
    <div>
        <span
            class="font-secundaria area-cadu"
            :class="disabled ? 'disabled-text': ''"
            :style="{ color: colorText }"
        >
            {{title}}
        </span>
        <textarea
            ref="textarea"
            :value="value"
            :disabled="disabled"
            @input="emitValue"
            class="textarea-cadu"
            :class=" {
              'cadu-textarea--disabled': disabled,
              'cadu_textarea--error': hasError,
              'cadu_textarea--success': hasSuccess
            }"
            :placeholder="placeholder"
            spellcheck="false"
            :minlength="min"
            :maxlength="max"
        >
        </textarea>
<!--         <transition name="fade">
          <span
              v-if="disabled ? '': errorMessage"
              :style="{ color: '#ED1651' }"
              class="font-secundaria help-cadu"
          >
              {{errorMessage}}
          </span>
        </transition> -->
    </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      required: false
    },
    height: {
      type: Number,
      required: false,
      default: 60
    },
    title: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    colorText: {
      type: String,
      required: false,
      default: '#60656C'
    },
    errorMessage: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    min: {
      type: String,
      required: false,
      default: ''
    },
    max: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      textAreaStyle: {
        'height': this.height + 'px',
        'color': this.colorText
      }
    }
  },
  methods: {
    emitValue () {
      this.$emit('input', this.$refs.textarea.value)
    }
  },
  computed: {
    hasError () {
      return !!this.errorMessage
    },
    hasSuccess () {
      return !!this.success
    }
  }
}
</script>

<style lang="sass" scoped>
$corBorda: #9E9E9E
$corFundoDisabled: #DEE2E6
$corError: #ED1651
$corSuccess: #00995D
$corTextoHabilitado: #54585e

.area-cadu
  margin-left: 2px
  font-size: 1.12em

.textarea-cadu
  outline: none
  box-sizing: border-box
  border: 1px solid $corBorda
  padding: 12px 20px
  border-radius: 4px
  font-size: 1.12em
  resize: none
  width: 100%
  overflow-y: auto
  color:$corTextoHabilitado

.cadu-textarea--disabled
  opacity: 0.6
  cursor: not-allowed
  background-color: $corFundoDisabled
  color:#222326

.cadu_textarea--error
  border-color: $corError

.cadu_textarea--success
  border-color: $corSuccess
</style>
